/* eslint-disable react/prop-types */
import React from "react";

const NoData = () => {
  return (
    <div className="flex flex-col items-center justify-center text-2xl" style={{height: '150px', gap: '8px'}}>
      <img style={{marginBottom: '6px'}} src="https://statichk.footprint.network/ab/tb-logo.png?x-oss-process=image/resize,m_fill,h_48,w_48" />
      <h3>No match result found in Telegraph Bay</h3>
      <span style={{color: '#959DA9'}}>Please try another search.</span>
    </div>
  );
};

export default NoData;
